import { isEqual } from "lodash";
import { useEffect, useState } from "react";

import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";

export const useInitializeStoredCourseIds = (
  facilityId: string | null,
  courseIds: string[],
  setCourseIds: (courseIds: string[]) => void
) => {
  const [filterLoaded, setFilterLoaded] = useState(false);
  useEffect(() => {
    if (!facilityId || filterLoaded) {
      return;
    }
    const loadFilters = async () => {
      try {
        const storedCourseIds = await getFiltersFromStorage(
          `x-whoosh-${facilityId}-course-ids`
        );

        const parsedCourseIds =
          storedCourseIds?.split(",")?.filter((id) => id.trim() !== "") || [];

        if (storedCourseIds && !isEqual(parsedCourseIds, courseIds)) {
          setCourseIds(parsedCourseIds);
        }
      } catch (error) {}
    };
    loadFilters().finally(() => {
      setFilterLoaded(true);
    });
  }, [facilityId, courseIds, setCourseIds, filterLoaded]);
};
